// THIS FILE IS GENERATED BY 'npm run set-env-variables'

export const environment = {
  production: true,

  // Configuration/Feature-switches:
  envName: '',
  useServiceWorker: true,
  useOffers: true,
  useQandAs: true,
  useQandASearch: true,
  useRegionPerLocale: false,
  useFeedbackPrompt: false,

  searchApi: '',
  searchApiKey: '',

  // Configuration of content
  localeLanguage: 'es',
  localeDir: 'ltr',
  localeAlternatives: 'en:English, es:Español, *:Other...',
  localeAlternativesExplanation: '* Traducido por Traductor de Google',
  appName: '',
  appLogoUrl: '',
  mainPageHeader: '',
  mainPageIntroduction: '\n \n',
  mainPageNotification: '',
  pageAbout: '\n',
  pagePrivacy: '\n',
  mainFooter: '**Información Relevante**  \n \n',
  errorHeader: 'Información Inaccesible',
  errorMessage: 'Contactanos: ',
  errorContactUrl: 'https://github.com/Cruz-Roja-Hondurena/Informacion',
  errorRetry: 'Intentar de nuevo?',

  // Regions:
  regionConfig: '',
  regions: 'info',
  regionsLabels: 'Información',
  regionsSheetIds: '1yePvW0YdIer0uxFV4ePhYMZKDftWcPdoWsid2j99mGs',

  // Third-party tokens:
  google_sheets_api_key: 'AIzaSyDtqNGanngQfZcAdylMH16Q5bplYekcxJk',
  google_sheets_api_url: 'https://sheets.googleapis.com/v4/spreadsheets',
  matomoConnectionString: '',
  appInsightsConnectionString: '',
};
